import { Banner, Slider } from "components";
import useWindowSize, { Size } from "hooks/useWindowSize";
import React, { useEffect } from "react";
import MainTemplate from "templates";
import About from "./About";
import History from "./History";
import Patners from "./Patners";
import HistoryMobile from "./HistoryMobile";
import Contact from "./Contact";
import News from "./News";
import * as S from "./style";

function Home() {
  const size: Size = useWindowSize();
  const mobile = size.width && size.width > 900;

  return (
    <MainTemplate>
      <Banner />
      <Slider />
      <S.Container>
        <About />
        {mobile ? <History /> : <HistoryMobile />}
        {/* <History /> */}
        <Patners />
        <News />
        <Contact />
      </S.Container>
      {/* <Slider /> */}
    </MainTemplate>
  );
}

export default Home;
